import { useFirestoreNoCompagny } from '../../firebase/useFirestore'

const EffectMeta = ({item}) => {

  const effects = useFirestoreNoCompagny('OutputEffects', 'ID', item ? item : '')

  return (
    <>
        {effects && effects.map((item) => (
            <p key={item.docid}>{item.Effect}</p>
        ))}
    </>
  )
}

export default EffectMeta